module.exports = __webpack_public_path__ + "img/hr-red-croton-10.26ea5432.png";